module.exports = __webpack_public_path__ + "img/bg_share.98eba745.png";